import { AppState, } from '../../types/AppState';

declare global {
  interface Window {
    dataLayer: any;
  }
}

const trackImpression = (pageData: AppState, panelName: string): void => {
  var eventResult = `${panelName}`;
  if(pageData?.consumerReviewAndRating?.consumerRating?.overallRating) {
    eventResult += `::${pageData.consumerReviewAndRating.consumerRating.overallRating}`
  }
  var data = getGaDataLayerImpressionEventObject(pageData, eventResult);
  var postMessageObject = getGaPostMessageObject(data, true);
  if(window) {
    window.postMessage(JSON.stringify(postMessageObject), '*');
    if(window.dataLayer?.push) {
      window.dataLayer.push(data);
    }
  }
};

/* Postmessage object template
{
  type: 'csAnalyticsEvent',
  event: {
    type: 'click|impression',
    googleAnalytics: {
      props: dataLayerPushObject
    }
}

*/
const getGaPostMessageObject = (gaDataLayerObject: any, isImpression = true): any => {
  var obj: any = {
    type: 'csAnalyticsEvent',
    event: {
      type: isImpression ? 'impression' : 'click',
      googleAnalytics: {
        props: gaDataLayerObject
      }
    }
  };
  return obj;
}

/* Datalayer push object template
{	
	'event': 'analytics_event',
	'eventElement': 'editorial-widget',
	'eventAction': 'impression',
	'eventResult': 'ratings::4.7',
	'eventNonInteractive': false,
	'eventData': {
    'vehicle': {
          'catalog': ''
          'makeId': ''
          'makeName': ''
          'modelId': ''
          'modelName': ''
          'trimName': ''
          'type': ''
    }
  }
}
*/
const getGaDataLayerImpressionEventObject = (pageData: AppState, eventResult: string): any => {
  var data: any = {
    event: 'analytics_event',
    eventElement: 'editorial-widget',
    eventAction: 'impression',
    eventResult: eventResult,
    eventNonInteractive: false,
  }

  return data;
}

export default { trackImpression, };
